import { Injectable } from '@angular/core';
import { BehaviorSubject, fromEvent, map, merge } from 'rxjs';


export type NetworkStatus = 'online' | 'offline';

@Injectable({
  providedIn: 'root'
})
export class NetworkService {
  #networkChange$ = new BehaviorSubject<NetworkStatus>(navigator.onLine ? 'online' : 'offline');
  get networkStatusObs () {
    return this.#networkChange$.asObservable();
  }
  
  get isOnline() : boolean {
    return navigator.onLine;
  }
  
  constructor() { 
    merge(
      fromEvent(window, 'offline').pipe(map(() => 'offline')),
      fromEvent(window, 'online').pipe(map(() => 'online'))
    ).subscribe(state => this.#networkChange$.next(state as NetworkStatus));
  }
}
